<template>
    <div>
        <h2 class="site-title">{{ $t('nav.users') }}</h2>
        <v-data-table
            :loading="loading"
            :headers="headers"
            :items="users">
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-spacer></v-spacer>
                    <user-register
                        :rules="rules"
                        @result="setNotification($event.message, $event.color)"
                        @reload="loadUsers"/>
                </v-toolbar>
            </template>
            <template v-slot:item.statusLabel="{ item }">
                <span v-if="item.statusLabel !== status.active">{{ item.statusLabel }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
                <user-edit
                    :rules="rules"
                    :user="item"
                    @result="setNotification($event.message, $event.color)"
                    @reload="loadUsers"/>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            fab small
                            class="mr-2"
                            :disabled="item.id === $auth.user().id"
                            :color="item.status === status.active ? 'grey darken-3' : 'green lighten-2'"
                            @click="toggleStatus(item)">
                            <v-icon v-if="item.status === status.active" color="white">
                                mdi-account-lock
                            </v-icon>
                            <v-icon v-else color="white">
                                mdi-account-convert
                            </v-icon>
                        </v-btn>
                    </template>
                    <span v-if="item.status === status.active">{{ $t('users.edit.ban') }}</span>
                    <span v-else>{{ $t('users.edit.unlock') }}</span>
                </v-tooltip>
            </template>
        </v-data-table>
        <v-snackbar
            v-model="alert.visibility"
            dark
            class="notification"
            :color="alert.color">
            {{ alert.message }}
        </v-snackbar>
    </div>
</template>

<script>
    import roles from '@/helpers/users/roles'
    import status from '@/helpers/users/status'
    import UserEdit from './users/Edit'
    import UserRegister from './users/Register'

    export default {
        components: {
            UserEdit, UserRegister
        },
        computed: {
            roles() {
                return roles.list
            },
            status() {
                return status
            },
            headers() {
                return [
                    {
                        text: this.$t('base.id'),
                        value: 'id',
                        align: 'right'
                    },
                    {
                        text: this.$t('users.created_at'),
                        value: 'created_at'
                    },
                    {
                        text: this.$t('users.email'),
                        value: 'email'
                    },
                    {
                        text: this.$t('users.forename'),
                        value: 'forename'
                    },
                    {
                        text: this.$t('users.surname'),
                        value: 'surname'
                    },
                    {
                        text: this.$t('users.role'),
                        value: 'role',
                    },
                    {
                        text: this.$t('users.status'),
                        value: 'statusLabel',
                    },
                    {
                        text: this.$t('base.actions'),
                        value: 'actions',
                        align: 'center',
                        sortable: false
                    }
                ]
            },
            users() {
                return this.$store.state.users
            }
        },
        data() {
            return {
                loading: false,
                newUser: null,
                rules: {
                    email: [
                        v => /[^@]+@[^\.]+\..+/.test(v) || this.$t('validation.email')
                    ],
                    password: [
                        v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/.test(v) || this.$t('validation.password')
                    ],
                    required: [
                        v => !!v || this.$t('validation.required')
                    ]
                },
                alert: {
                    visibility: false,
                    message: "",
                    color: "primary"
                }
            }
        },
        methods: {
            loadUsers() {
                this.loading = true
                this.$store.dispatch('loadUsers', true)
                    .then(() => {
                        this.loading = false
                    })
                    .catch(() => {
                        this.loading = false
                        this.setNotification(this.$t('users.loadingFail'), 'error')
                    })
            },
            setNotification(message, color = 'primary') {
                this.alert = {
                    visibility: true,
                    message,
                    color
                }
                window.setTimeout(() => {
                    this.alert.visibility = false
                }, 4500)
            },
            toggleStatus(user) {
                let type = user.status === status.active ? 'suspend' : 'unlock'
                if (confirm(this.$t('users.' + type + '.confirm', {email: user.email}))) {
                    this.loading = true
                    this.$http.post('users/toggle-status', {id: user.id})
                        .then(() => {
                            this.loading = false
                            this.setNotification(this.$t('users.' + type + '.success'))
                            this.loadUsers()
                        })
                        .catch(() => {
                            this.loading = false
                            this.setNotification(this.$t('users.' + type + '.fail'), 'error')
                        })
                }
            }
        },
        created() {
            this.loadUsers()
        }
    }
</script>

<style>
    .alert-enter-active, .alert-leave-active {
        transition: opacity .4s;
    }
</style>
